import React, { useState } from 'react';
import { Title, Text, Link, Modal } from '@gjensidige/builders-components';
import './InformationModal.scss';

interface IInfoProps {
  linkText?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modalContent: any;
  modalAriaLabel?: string;
  buttonSize?: 'sm' | 'md';
  heading?: string;
  buttonClassName?: string;
  leftAlignedLink?: boolean;
  ariaDescribedBy?: string;
  secondaryButtonAction?: () => void;
  openCallBack?: (isOpen: boolean) => void;
}

export const InformationModal: React.FC<IInfoProps> = (props: IInfoProps) => {
  const [closeModal, setCloseModal] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onModalClose = (event?: any) => {
    event && event.preventDefault();
    setCloseModal(false);
    if (props.openCallBack) {
      props.openCallBack(!closeModal);
    }
  };

  const openModal = (event?: any) => {
    event && event.preventDefault();
    setCloseModal(true);
    if (props.openCallBack) {
      props.openCallBack(true);
    }
  }

  const handleKeyDown = (event?: any) => {
    if (event?.key === 'Enter') {
      setCloseModal(!closeModal);
    }
  };

  return (
    <>
      <div
        className={`more-info-text-wrapper ${props.leftAlignedLink
          ? 'more-info-left-align'
          : 'more-info-center-align'
          }`}
      >
        {/* on click or on enter key press */}
        <Link
          href="#"
          onClick={(event: any) => openModal(event)}
          onKeyDown={(event: any) => handleKeyDown(event)}
          {...(props.ariaDescribedBy) ? { id: props.ariaDescribedBy } : {}}
        >
          {props.linkText}
        </Link>
      </div>
      <Modal
        aria-label={props.modalAriaLabel || "Hjälpinformation"}
        className=""
        open={closeModal}
        strict={false}
        onClose={onModalClose}
        closeLabel="Stäng hjälptext"
        variant="box"
        onKeyDown={onModalClose}
      >

        {props.heading && (
          <Title as="h2" size="4" className="more-info-modal-heading">
            {props.heading}
          </Title>
        )}
        <div className="more-info-modal-content pt-2">
          {props.modalContent.length > 0 &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            props.modalContent.map((descriptionList: any, index: number) => {
              return (
                <div key={index} className="pb-2">
                  <Title as="h2" size="5" className="pb-1">
                    {descriptionList.title}
                  </Title>
                  {descriptionList.details
                    ?.split('\n')
                    .map((text: string, index: number) => {
                      return (
                        <div
                          className={text.trim().length > 0 ? '' : 'pt-1'}
                          key={index}
                        >
                          <Text size="body" className="info-modal-message">{text}</Text>
                        </div>
                      );
                    })}
                </div>
              );
            })}
        </div>
      </Modal>
    </>
  );
};
